import React from "react";
import {useStores} from "../../stores/useStores";
import {IconSource} from "../../shared/enums/iconSource";
import MenuItem from "../../components/atoms/menu/menuItem";
import {RoutePaths} from "../../shared/routePaths";

const LogoutButton: React.FC = () => {
  const {
    uiStore: {accountStore}
  } = useStores();

  const onSignOutClick = () => {
    window.location.href =
      accountStore.endpoints.signOut + "?returnurl=" + RoutePaths.SignIn;
  };
  return accountStore.isAuthenticated ? (
    <MenuItem
      title="Logout"
      icon={IconSource.logout}
      onClick={onSignOutClick}
      scoped={true}
    />
  ) : (
    <></>
  );
};

export default LogoutButton;
